// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Yf\\+7VJ0lwXBoLjoLTpaJfQ\\=\\={position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);text-align:center;width:100%}", "",{"version":3,"sources":["webpack://./src/shared/components/EmptyPageNotifiers/EmptyPageNotifier.module.scss"],"names":[],"mappings":"AAIA,6BACI,iBAAA,CACA,OAAA,CACA,QAAA,CACA,+BAAA,CACA,iBAAA,CACA,UAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty_notification": "Yf+7VJ0lwXBoLjoLTpaJfQ=="
};
export default ___CSS_LOADER_EXPORT___;
